import http from '../plugins/axios'

export const getAllProductsList = async (params) => {
  try {
    const response = await http.get(`/api/v2/products`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getDetailProduct = async (productId, params) => {
  try {
    const response = await http.get(`/api/v2/products/${productId}`, { headers: { 'Identifier': 'manage' }, params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const addProduct = async (payload) => {
  try {
    const response = await http.post(`/api/v2/products`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const addProductUrl = async (payload) => {
  try {
    const response = await http.post(`/api/v2/importer`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const addProductUrlShopee = async (url, payload) => {
  try {
    const response = await http.post(`/api/v2/importer/shopee?url=${url}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const addProductUrlChinabuybuy = async (url, payload) => {
  try {
    const response = await http.post(`/api/v2/importer/chinabuybuy?url=${url}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const addProductUrlAmazon = async (payload) => {
  try {
    const response = await http.post(`/api/v2/importer/amazon`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const editProduct = async (productId, payload) => {
  try {
    const response = await http.put(`/api/v2/products/${productId}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteProduct = async (productId) => {
  try {
    const response = await http.delete(`/api/v2/products/${productId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const reMarkupProduct = async (productId, payload) => {
  try {
    const response = await http.put(`/api/v2/products/${productId}/remarkup`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}


export const cloneProduct = async (payload) => {
  try {
    const response = await http.post('/api/v2/products/clone', payload)
    return response.data
  } catch (error) {
    throw error
  }
}

// product language
export const getProductLanguage = async (productId) => {
  try {
    const response = await http.get(`/api/v2/products/${productId}/languages?timestamp=${new Date().getTime()}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const addProductLanguage = async (productId, payload) => {
  try {
    const response = await http.post(`/api/v2/products/${productId}/languages`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const convertFileToImageVariant = async (payload) => {
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  try {
    const response = await http.post('/api/v2/products/variant/image', payload, config)
    return response.data
  } catch (error) {
    throw error
  }
}

export const downloadImageProductDescription = async (productId) => {
  try {
    const response = await http.get(`/api/v2/products/download-description-images/${productId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const adjustImageProduct = async (productId, payload) => {
  try {
    const response = await http.put(`/api/v2/products/${productId}/images`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const addImageProductUrl = async (payload) => {
  try {
    const response = await http.put('/api/v2/products/update-bulk', payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateBulkProduct = async (payload) => {
  try {
    const response = await http.put('/api/v2/products/update-bulk', payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateBulkProductStatus = async (payload) => {
  try {
    const response = await http.put('/api/v2/products/update-bulk/status', payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteBulkProduct = async (payload) => {
  try {
    const response = await http.delete('/api/v2/products/bulk-delete', { data: payload })
    return response.data
  } catch (error) {
    throw error
  }
}

export const addImageProductUpload = async (productId, payload) => {
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  try {
    const response = await http.post(`/api/v2/products/${productId}/updateimages`, payload, config)
    return response.data
  } catch (error) {
    throw error
  }
}

export const setMainImage = async (productId, payload) => {
  try {
    const response = await http.post(`/api/v2/products/${productId}/image/set-main`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateRecommendUser = async (productId, payload) => {
  try {
    const response = await http.post(`/api/v2/products/${productId}/recommend`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateExclusiveUser = async (productId, payload) => {
  try {
    const response = await http.post(`/api/v2/products/${productId}/exclusive`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getCollectorDataProduct = async (productId, params) => {
  try {
    const response = await http.get(`/api/v2/products/${productId}/collectors`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

// Sub Products / Branch
export const addSubProduct = async (productId) => {
  try {
    const response = await http.post(`/api/v2/products/${productId}/branch`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const syncPricingSubProduct = async (productId) => {
  try {
    const response = await http.post(`/api/v2/products/${productId}/sync-pricing`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const syncGeneralSubProduct = async (productId) => {
  try {
    const response = await http.post(`/api/v2/products/${productId}/sync-generic`)
    return response.data
  } catch (error) {
    throw error
  }
}